import { createModalSlice } from 'shared/lib/factory/redux/createModalSlice'

export const cancelSubscriptionModalSlice = createModalSlice('cancelSubscriptionModal')

export const cancelSubscriptionModalActions = cancelSubscriptionModalSlice.actions
